<template>
  <div class="flex-box bg-white bar-padding">
    <van-nav-bar :title="title">
      <template #left>
        <van-icon name="arrow-left" size="20" color="#333" @click="$router.back()" />
      </template>
      <template #right>
        <van-icon name="search" size="20" color="#333" @click="goSearch" />
      </template>
    </van-nav-bar>
    <van-dropdown-menu>
      <van-dropdown-item v-model="query.categoryId" :options="option1" @change="onCategoryChange" />
      <van-dropdown-item v-model="query.sortType" :options="option2" @change="onSortChange" />
      <!-- <van-dropdown-item title="筛选">
        <div>

        </div>
        <div style="padding: 5px 16px;">
          <van-button type="danger" block round @click="onConfirm">
            确认
          </van-button>
        </div>
      </van-dropdown-item> -->
    </van-dropdown-menu>
    <div class="flex-box-main list-content" ref="listContent" id="sc1" v-scroll-container:backTop1>
      <van-pull-refresh v-model="refishing" @refresh="onRefresh" class="pull-content">
        <van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" @load="onLoad">
          <div class="product-list">
            <div class="product-item" v-for="(item, index) in list" :key="item.ProId"
              :class="[index % 2 === 0 ? 'item-l' : 'item-r']">
              <ProductItemBox :product="item"></ProductItemBox>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <BackToTop ref="backTop1" target-id="sc1"></BackToTop>
    </div>
  </div>
</template>

<script>
import ProductItemBox from "@/components/ProductItemBox.vue";
import { getSubCategoryList } from "@/api/common";
import BackToTop from "@/components/BackToTop.vue"

export default {
  name: "search-category",
  components: { ProductItemBox, BackToTop },
  data () {
    return {
      title: "",
      activeKey: 0,
      categoryId: 0,
      parentCategoryId: 0,
      parentCategoryName: "",
      scroll: 0,
      refishing: false,
      list: [],
      loading: false,
      initLoading: false,
      finished: false,
      categories: [],
      query: {
        categoryId: 0,
        pcId: 0,
        sortType: 0,
        size: 10,
        page: 1,
        source: this.$store.getters.source,
      },
      option1: [{ text: "全部", value: 0 }],
      option2: [
        { text: "默认排序", value: 0 },
        { text: "价格最低", value: 1 },
        { text: "价格最高", value: 2 },
      ],
      option3: [
        { text: "默认排序", value: 0 },
        { text: "价格最低", value: 1 },
        { text: "价格最高", value: 2 },
      ],
    };
  },
  created () {
    //this.fetchData();
    this.initData();
  },
  beforeRouteEnter (to, from, next) {
    // console.log(to, from);
    if (from.name === "detail" || from.name === "zhichong") {
      next(() => {
        //console.log(to.meta.scrollPosition);
        // if (to.meta.scrollPosition) {
        //   vm.$refs.listContent.scrollTop = to.meta.scrollPosition;
        // }
        // let listContent = vm.$refs.listContent;
        // console.log(vm.scroll, listContent.scrollTop);
        // // 记录滚动高度
        // listContent.scrollTop = vm.scroll;
        // // 不重新请求数据
        // //vm.notFetchData()
        // console.log(listContent.scrollTop);
        // listContent.scrollTo(0, vm.scroll);
      });
    } else {
      next((vm) => {
        const listContent = vm.$refs.listContent;
        // 不记录滚动高度
        listContent.scrollTop = 0;
        vm.scroll = 0;
        if (to.query.categoryId) vm.query.categoryId = to.query.categoryId;
        if (to.query.pcId) {
          vm.parentCategoryId = to.query.pcId;
          vm.query.pcId = to.query.pcId;
        }
        if (to.query.categoryName) vm.title = to.query.categoryName;
        //vm.refishing = true;
        vm.query.sortType = 0;
        vm.initData();
        // 重新请求数据
        vm.fetchData();
      });
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === "detail" || to.name === "zhichong") {
      let listContent = this.$refs.listContent;
      this.scroll = listContent.scrollTop;
      // from.meta.scrollPosition = listContent.scrollTop;
    } else {
      from.meta.keepAlive = false;
    }
    next();
  },
  activated () {
    this.$refs.listContent.scrollTop = this.scroll;

  },
  mounted () {
    // console.log(this.$route.meta.scrollPosition);
    // if (this.$route.meta.scrollPosition) {
    //   this.$refs.listContent.scrollTop = this.$route.meta.scrollPosition;
    // }
  },
  watch: {
    $route (to, from) {
      if (from.name === "category") {
        //重新加载
        this.title = this.$route.query.categoryName;
        this.categoryId = this.$route.query.categoryId;
        //this.onRefresh();
      }
    },
  },
  methods: {
    initData () {
      let list = [{ text: "全部", value: 0 }];
      getSubCategoryList(this.$route.query.pcId).then((response) => {
        //console.log(response);
        if (response.data.code === 1) {
          let clist = response.data.data[0].Children.map((item) => {
            return { text: item.Name, value: item.Id };
          });
          this.option1 = list.concat(clist);
          this.title = response.data.data[0].Name;
          this.query.categoryId = Number(this.$route.query.categoryId);
          this.query.pcId = Number(this.$route.query.pcId);
        }
      });
    },
    onRefresh () {
      //this.list = [];
      this.query.page = 1;
      this.finished = false;
      this.loading = true;
      this.loadProduct("refresh");
    },
    fetchData () {
      //console.log(this.$router);
      this.query.page = 1;
      this.loading = true;
      this.finished = false;
      this.loadProduct("fetch");
    },
    loadProduct (f) {
      console.log(f);
      //加载商品信息
      this.$ajax
        .get("api/product/list", {
          params: this.query,
        })
        .then((response) => {
          this.loading = false;
          this.refishing = false;
          if (response.data.code === 1) {
            let data = response.data.data;
            if (data.length === 0 || data.length < this.query.size) {
              this.finished = true;
              //console.log("完成");
            }
            if (this.query.page === 1) {
              this.list = response.data.data;
            } else {
              this.list = this.list.concat(data);
            }
            this.query.page++; //增加页码
          }
        });
    },
    onLoad () {
      if (this.refishing) {
        this.list = [];
        this.refishing = false;
      }
      this.loadProduct("list");
    },
    onCategoryChange () {
      this.onRefresh();
    },
    onSortChange () {
      this.onRefresh();
    },
    goSearch () {
      this.$router.push({ path: "search", query: { from: "searchcategory" } });
    },
  },
};
</script>

<style lang="less" scoped>
.list-content {
  display: flex;
  overflow-y: auto;
  padding-top: 10px;
  background-color: #f5f5f5;
}

.product-list {
  display: flex;
  flex-wrap: wrap;

  .product-item {
    width: 50%;
    box-sizing: border-box;
    padding: 0 10px 10px 10px;
  }

  .item-l {
    padding-right: 5px;
  }

  .item-r {
    padding-left: 5px;
  }
}
</style>
